<template>
  <div>
    <slot v-if="requestStatus.isSuccess" />
    <LoadingCircle v-if="requestStatus.isLoading" />
    <span v-if="requestStatus.isError" class="error-message">
      Vabandust, {{ errorMessage }}.<br />
      Palun proovi lehte värskendada vajutades <code>ctrl+shift+R</code>.<br />
      Kui viga püsib, siis palun anna sellest meile teada.
    </span>
  </div>
</template>

<script>
import LoadingCircle from '@/components/LoadingCircle'
import { ApiRequestStatus } from '@/dataAccess/ApiRequestStatus'

export default {
  components: { LoadingCircle },
  props: {
    requestStatus: {
      type: ApiRequestStatus,
      required: true
    },
    errorMessage: {
      type: String,
      default: 'Laadimine ebaõnnestus'
    }
  }
}
</script>

<style scoped>
.error-message {
  color: red;
}
</style>
